const c=["cartebancaire","bcmc","dankort"];export{c as DUAL_BRANDS_THAT_NEED_SELECTION_MECHANISM};
//# sourceMappingURL=constants.js.map
